// extracted by mini-css-extract-plugin
export var leftAlign = "_1i-2";
export var popper = "_1i-0";
export var subtitle = "_1i-1";